export default function DOM_NodeList() {
  return (
    <div>
      <h1>DOM_NodeList</h1>
      <p>This is the DOM_NodeList component.</p>
    </div>
  );
}